
/**
 * @export
 * @enum {string}
 */
export enum DraftStatus {
    IN_PROGRESS = 'IN_PROGRESS',
    FINALIZED = 'FINALIZED',
    ERROR = 'ERROR'
}